import React from 'react';

// Shared "Program Highlights" strip — 7-column icon grid used across all program pages.
const ProgramHighlightsSection = ({ items = [], accentColor = '#16A34A', iconBg = '#F0FDF4', iconBorder = '#BBF7D0', cardBorder = '#D1FAE5' }) => (
  <section style={{ padding: '0 4%', background: '#ffffff' }}>
    <style>{`
      .phs-grid { display:grid; grid-template-columns:repeat(7,1fr); gap:8px; }
      @media (max-width:900px) { .phs-grid { grid-template-columns:repeat(3,1fr); } }
      @media (max-width:480px) { .phs-grid { grid-template-columns:repeat(2,1fr); } }
    `}</style>
    <div style={{ maxWidth: 1280, margin: '0 auto', border: `1.5px solid ${cardBorder}`, borderRadius: '0 0 16px 16px', padding: '28px 32px', background: '#fff' }}>
      <h3 style={{ textAlign: 'center', fontSize: 16, fontWeight: 900, color: '#1E293B', letterSpacing: '0.06em', margin: '0 0 24px' }}>PROGRAM HIGHLIGHTS</h3>
      <div className="phs-grid">
        {items.map((h) => (
          <div key={h.label} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, textAlign: 'center', padding: '10px 6px' }}>
            <div style={{ width: 46, height: 46, borderRadius: 10, background: iconBg, border: `1px solid ${iconBorder}`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: accentColor }}>{h.icon}</div>
            <span style={{ fontSize: 11, fontWeight: 600, color: '#374151', lineHeight: 1.4 }}>{h.label}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ProgramHighlightsSection;
